import { render } from "./ChoseOption.vue?vue&type=template&id=0a8ae5c6"
import script from "./ChoseOption.vue?vue&type=script&lang=js"
export * from "./ChoseOption.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__